export default () => {
  return (
    <div className='header-block'>
      <div className='header'></div>
    </div>
  );
}